module.exports = __webpack_public_path__ + "static/img/DOA-banner.d8c10b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/DOA-banner.jpg
// module id = YtpE
// module chunks = 49